import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { BackgroundProvider } from "./context/BackgroundContext";
import { MemberProvider } from "./context/MemberContext";
import { Navigation } from "./components/Navigation";
import { Footer } from "./components/Footer";
import { Bridge } from "./pages/Bridge";
import { Hangar } from "./pages/Hangar";
import { Personnel } from "./pages/Personnel";
import { WarRoom } from "./pages/WarRoom";
import { Announcements } from "./pages/Announcements";
import { Operations } from "./pages/Operations";
import { Login } from "./pages/Login";
import { Admin } from "./pages/Admin";
import { MemberAuth } from "./pages/MemberAuth";

function App() {
  return (
    <AuthProvider>
      <MemberProvider>
        <BackgroundProvider>
          <div className="App">
            <BrowserRouter>
              <Navigation />
              <Routes>
                <Route path="/" element={<Bridge />} />
                <Route path="/hangar" element={<Hangar />} />
                <Route path="/personnel" element={<Personnel />} />
                <Route path="/war-room" element={<WarRoom />} />
                <Route path="/announcements" element={<Announcements />} />
                <Route path="/operations" element={<Operations />} />
                <Route path="/login" element={<Login />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="/member" element={<MemberAuth />} />
              </Routes>
              <Footer />
            </BrowserRouter>
          </div>
        </BackgroundProvider>
      </MemberProvider>
    </AuthProvider>
  );
}

export default App;
